(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.repeat) return;
    if (!event.target.hasAttribute('data-checkbox-enter')) return;

    event.preventDefault();
    event.target.checked = !event.target.checked;
    event.target.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.column-option');
    if (!btn) return;

    const wrapper = btn.closest('.column-options-wrapper');
    const radio = wrapper.querySelector(`.column-options__radio[value="${btn.dataset.value}"]`);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    wrapper.querySelectorAll('.column-option').forEach((b) => {
      const isActive = b.dataset.value === btn.dataset.value;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', String(isActive));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rolling-usps"] && !Shopify.designMode) return;
  try {
    class RollingUsps extends HTMLElement {
    connectedCallback() {
      if (!this.ready) this.init();
      if (!this.ready) return;
      if (!this.observer) {
        this.observer = new IntersectionObserver((entries) => {
          this.onVisibilityChange(entries[0].isIntersecting);
        });
      }
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopLoop();
      if (this.observer) this.observer.unobserve(this);
    }

    init() {
      this.ready = false;
      this.count = this.querySelectorAll('.rolling-usps__line').length;
      // Single message (or fewer) needs no rotation.
      if (this.count < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.track = this.querySelector('.rolling-usps__track');
      this.progress = this.querySelector('.rolling-usps__ring-progress');
      this.button = this.querySelector('.rolling-usps__timer');
      this.duration = parseFloat(this.dataset.duration) || 6;
      this.current = 0;
      this.elapsed = 0;
      this.paused = false;

      if (this.button) {
        this.button.addEventListener('click', () => this.toggle());
      }
      this.move();
      this.ready = true;
    }

    onVisibilityChange(isVisible) {
      if (isVisible && !this.paused) this.startLoop();
      else this.stopLoop();
    }

    startLoop() {
      if (this.raf) return;
      let last = null;
      const loop = (now) => {
        this.raf = requestAnimationFrame(loop);
        if (last === null) {
          last = now;
          return;
        }
        this.elapsed += (now - last) / 1000;
        last = now;
        if (this.elapsed >= this.duration) {
          this.elapsed = 0;
          this.current = (this.current + 1) % this.count;
          this.move();
        }
        this.drawRing();
      };
      this.raf = requestAnimationFrame(loop);
    }

    stopLoop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    toggle() {
      this.paused = !this.paused;
      if (this.paused) {
        this.stopLoop();
        this.classList.add('rolling-usps--paused');
        if (this.button) {
          this.button.setAttribute('aria-label', this.dataset.playLabel || 'Play');
        }
      } else {
        this.classList.remove('rolling-usps--paused');
        if (this.button) {
          this.button.setAttribute('aria-label', this.dataset.pauseLabel || 'Pause');
        }
        this.startLoop();
      }
    }

    move() {
      if (!this.track) return;
      this.track.style.transform =
        'translateY(calc(-1 * ' + this.current + ' * (var(--rolling-usps-line-height) + var(--rolling-usps-gap))))';
    }

    drawRing() {
      if (!this.progress) return;
      const progress = Math.min(this.elapsed / this.duration, 1);
      this.progress.style.strokeDashoffset = String(100 - progress * 100);
    }
  }

  if (!customElements.get('rolling-usps')) {
    customElements.define('rolling-usps', RollingUsps);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-predictive-drawer"] && !Shopify.designMode) return;
  try {
    class SearchDrawerButtonUpdater {
    constructor() {
      const panel = document.querySelector('.search-drawer-panel');
      if (!panel) return;

      const button = panel.querySelector('.search-drawer-panel__show-results-button');
      const results = panel.querySelector('.search-drawer-panel__results');
      if (!button || !results) return;

      this.button = button;
      this.results = results;
      this.defaultText = button.dataset.defaultText || 'Show results';
      this.countTemplate = button.dataset.countText || 'Show results (__COUNT__)';

      const observer = new MutationObserver(() => this.update());
      observer.observe(results, { childList: true, subtree: true });
      this.update();
    }

    update() {
      const hasResults = this.results.querySelector('[data-search-results]');
      const noResults = this.results.querySelector('.predictive-search-results__no-results');

      if (hasResults && !noResults) {
        const products = this.results.querySelectorAll('.predictive-search-results__card--product');
        const pages = this.results.querySelectorAll('.predictive-search-results__page-row');

        if (products.length > 0) {
          this.button.textContent = this.countTemplate.replace('__COUNT__', String(products.length));
          this.button.disabled = false;
        } else if (pages.length > 0) {
          this.button.textContent = this.defaultText;
          this.button.disabled = false;
        } else {
          this.button.textContent = this.defaultText;
          this.button.disabled = true;
        }
      } else {
        this.button.textContent = this.defaultText;
        this.button.disabled = true;
      }
    }
  }

  new SearchDrawerButtonUpdater();

  const drawerForm = document.getElementById('search-drawer-form');
  if (drawerForm) {
    drawerForm.addEventListener('submit', () => {
      const results = drawerForm.querySelector('.search-drawer-panel__results');
      const typeInput = drawerForm.querySelector('input[name="type"]');
      if (!results || !typeInput) return;

      const products = results.querySelectorAll('.predictive-search-results__card--product');
      if (products.length === 0) {
        const linkResults = results.querySelectorAll('.predictive-search-results__page-row');
        if (linkResults.length > 0) {
          typeInput.value = 'page,article';
        }
      }
    });
  }

  const drawerPanel = document.querySelector('.search-drawer-panel');
  if (drawerPanel) {
    drawerPanel.querySelectorAll('[role="listbox"]').forEach((el) => {
      el.removeAttribute('role');
      el.removeAttribute('aria-expanded');
    });

    const searchInput = drawerPanel.querySelector('.search-drawer-panel__input');
    const overlayPanel = drawerPanel.closest('.drawer-overlay__panel');
    if (searchInput && overlayPanel) {
      new MutationObserver(() => {
        if (getComputedStyle(overlayPanel).display !== 'none') {
          setTimeout(() => searchInput.focus({ preventScroll: true }), 60);
        }
      }).observe(overlayPanel, { attributes: true, attributeFilter: ['style'] });
    }

    drawerPanel.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-search-prompt]');
      if (!pill) return;

      const term = pill.dataset.searchPrompt;
      const input = drawerPanel.querySelector('.search-drawer-panel__input');
      if (!input) return;

      input.focus();
      input.value = '';
      document.execCommand('insertText', false, term);

      const reset = drawerPanel.querySelector('.search-drawer-panel__clear-button');
      if (reset) reset.hidden = false;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
